const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class PhoneInput {
  constructor(data, placeholder, validator) {
    this._data = data;
    this.element = cELM("div", "option-block");
    this.placeholder = placeholder || "";
    this.type = "tel";

    this.validator = validator;
    this.elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    const inputEl = cELM("input", "text-input mr");
    inputEl.placeholder = this.placeholder;
    inputEl.type = this.type;
    inputEl.pattern = "\d*";
    inputEl.autofocus = true;
    inputEl.maxLength = 14;

    const buttonEl = cELM("div", "go-button", "Go");
    buttonEl.onclick = function(evt) {
      const op = inputEl.value;
      inputEl.classList.remove("invalid");

      if (_self.validator && !_self.validator(op)) {
        inputEl.classList.add("invalid");
        inputEl.focus();
        return;
      }

      let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(op) : op;

      data = (typeof data == 'string') 
          ? { text: data, id: _self._data.id }
          : { ...data, id: _self._data.id };

      data.answerKey = _self._data.answerKey;

      Chat.default.send(data, null, _self.element);
    };

    const fnChange = function(evt) {
      if (evt.keyCode === 8) return false;

      const onlyNumber = evt.target.value
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "");
      if (onlyNumber.length === 10) {
        inputEl.blur();
        buttonEl.click();
        return;
      }
      const zip = onlyNumber.substring(0, 3);
      const middle = onlyNumber.substring(3, 6);
      const last = onlyNumber.substring(6, 10);

      let formatted = "";
      if (onlyNumber.length >= 6) {
        formatted = `(${zip}) ${middle}-${last}`;
      } else if (onlyNumber.length > 2) {
        formatted = `(${zip}) ${middle}`;
      } else if (onlyNumber.length > 0) {
        formatted = `(${zip}`;
      }

      evt.target.value = formatted;
    };

    inputEl.onkeydown = function(evt) {
      return evt.keyCode === 8 || (evt.keyCode >= 48 && evt.keyCode <= 57) || (evt.keyCode >= 96 && evt.keyCode <= 105);
    };
    inputEl.onkeyup = fnChange;

    this.element.addELM(Wrap4Arrow(inputEl, true));
    this.element.addELM(buttonEl);
    this.elements = { el: inputEl, btn: buttonEl };

    return this.element;
  }

  reset() {
    this.element.firstChild.value = "";
    this.element.firstChild.focus();
  }

  focus() {
    //this.elements.el.focus();
  }
}

module.exports = PhoneInput;
